<template>
  <main>
    <h2 class="ttl">{{$t('withdrawComplete')}}</h2>
    <p class="center">{{$t('withdrawComplete2')}}</p>
    <p class="btn-normal-2 mt60">
      <router-link :to="{ name: 'Signin' }">{{$t('toLogin')}}</router-link>
    </p>
  </main>
</template>

<script>
export default {
  name: 'WithdrawCompleted'
}
</script>
